import { Component, OnInit } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ACCOUNTS,
  ACTIVE_SUBSCRIPTIONS_CCV,
  FUNDS_LIST,
} from 'src/app/shared/common/constants';
import { ICurrentSubscription } from 'src/app/shared/interfaces/subscription.interface';
import { ApvConfigService } from '../../core/services/firestore/apv-config.service';
import {
  IFundOption,
  MULTI_FUNDS,
} from '../../subscription/constants/regime-fund.constant';
import { GlobalStorage } from '../../core/services/globals.service';
import { BffService } from '../../core/services/http/bff.http.service';
import { IonicStorageService } from '../../core/services/storage/ionic/storage.service';
import { IRentability } from './account-detail.interface';

const CCV_ACCOUNT_ID = 'CCV';
@Component({
    selector: 'account-detail',
    templateUrl: './account-detail.component.html',
    styleUrls: ['./account-detail.component.scss'],
    standalone: false
})
export class AccountDetailComponent implements OnInit {
  selectedAccount: any = {};
  loaded: boolean = false;
  showSubscriptionsSkeleton = true;
  subscriptionsDataLoaded = false;
  subscriptionsDataFailed = false;
  changeAmmount: number = 0;
  subscriptions: ICurrentSubscription[] = [];
  rentability: IRentability[] = [];
  fundSelectedValue: string = FUNDS_LIST.C;
  fundSelectedPercentage: number = 0;
  amount: number = 0;
  fundDisplayName: string = '';
  constructor(
    private readonly router: Router,
    private readonly globalSvc: GlobalStorage,
    private readonly bffSvc: BffService,
    private readonly firebaseAuth: Auth,
    private readonly route: ActivatedRoute,
    private readonly ionicStorage: IonicStorageService,
    private readonly apvConfigSvc: ApvConfigService,
  ) {}

  async ngOnInit() {
    this.initAccountDetails();
    this.getAccountCondition();
  }

  async getAccountCondition() {
    const accountCondition = sessionStorage.getItem(
      'accountInformationSelected'
    );
    if (accountCondition) {
      this.selectedAccount = JSON.parse(accountCondition);
      this.loaded = true;
      this.loadFundName();
    } else {
      const allAccounts = await this.ionicStorage.get(ACCOUNTS);

      const accountInformation = allAccounts.find(
        (account: any) => account.id === CCV_ACCOUNT_ID
      );
      sessionStorage.setItem(
        'accountInformationSelected',
        JSON.stringify(accountInformation)
      );

      this.selectedAccount = accountInformation;
      this.loaded = true;
      this.loadFundName();
    }
  }

  get multiFund(): IFundOption | undefined {
    const fundId = this.selectedAccount?.funds?.[0]?.id;
    return MULTI_FUNDS.find((fund) => fund.id === fundId);
  }

  private loadFundName(): void {
    const fundId = this.selectedAccount?.funds?.[0]?.id;

    if (!fundId) return;

    this.apvConfigSvc.fundNames().subscribe((fundNames) => {
      this.fundDisplayName =
        fundNames.find((fund) => fund.id === fundId)?.name ?? '';
    });
  }

  private async initAccountDetails(): Promise<void> {
    await this.storeTokenIntoGlobalStorage();
    this.getAndSetRentability();
    /*
      Lo siguiente para actualizar el monto
      una vez se realiza una modificacion
      en el modal
    */
    this.route.url.subscribe((url) => {
      this.subscriptionsDataLoaded = false;
      this.showSubscriptionsSkeleton = true;
      this.getAndSetSubscriptionDetails();
    });
  }

  private async storeTokenIntoGlobalStorage(): Promise<void> {
    try {
      const firebasetoken = await (
        await this.firebaseAuth.currentUser
      )?.getIdToken();
      this.globalSvc.token = String(firebasetoken);
    } catch (error) {
      console.error('Error storing token:', error);
      throw error;
    }
  }

  private updateFundPercentage(): void {
    const findFundPercentage = this.rentability.find(
      (fund) => fund.id
    ) as IRentability;
    this.fundSelectedPercentage = findFundPercentage.value;
  }

  private async getAndSetRentability(): Promise<void> {
    try {
      if (this.globalSvc.rentability.length === 0) {
        const res = await this.bffSvc.getRentability();
        this.rentability = res.data.data.result;
        this.globalSvc.rentability = res.data.data.result;

      } else {
        this.rentability = this.globalSvc.rentability;
      }
      this.updateFundPercentage();
    } catch (error: any) {
      console.log('Error getting rentability');
      console.log(error.message);
    }
  }

  goBack() {
   void this.router.navigate(['/home/CCV']);
  }

  private async getAndSetSubscriptionDetails(): Promise<void> {
    try {
      const subscriptionsStorage = await this.ionicStorage.get(
        ACTIVE_SUBSCRIPTIONS_CCV
      );

      if (subscriptionsStorage && subscriptionsStorage.length > 0) {
        this.subscriptionsDataLoaded = true;
        this.showSubscriptionsSkeleton = false;
        this.globalSvc.activeSubscriptions = subscriptionsStorage;
        this.subscriptions = subscriptionsStorage;
      } else {
        const res = await this.bffSvc.getActiveSubscriptions();
        if (res.data?.data?.result?.data?.length > 0) {
          this.subscriptionsDataLoaded = true;
          this.showSubscriptionsSkeleton = false;
          this.globalSvc.activeSubscriptions = res.data.data.result.data;
          this.subscriptions = res.data.data.result.data;
        } else {
          console.error('No active subscriptions');
          this.subscriptionsDataFailed = true;
        }
      }
    } catch (error: any) {
      console.error('Error getting subscriptions');
      console.log(error.message);
      this.showSubscriptionsSkeleton = false;
      this.subscriptionsDataFailed = true;
    }
  }
}
